import * as actions from 'actions/eventSuppressions';

const defaultState = {
  filterDetails: {},
};

export default function eventSuppressions(state = defaultState, action) {
  switch (action.type) {
    case actions.LOAD_START:
      return {
        ...state,
        [action.payload.eventId]: {
          ...state[action.payload.eventId],
          loading: true,
          error: false,
          data: [],
          ...action.payload,
        },
      };
    case actions.LOAD_FAIL:
      return {
        ...state,
        [action.initialPayload.eventId]: {
          ...state[action.initialPayload.eventId],
          loading: false,
          error: true,
        },
      };
    case actions.LOAD_SUCCESS:
      return {
        ...state,
        [action.payload.eventId]: {
          ...state[action.payload.eventId],
          loading: false,
          error: false,
          total: action.payload.total,
          links: action.payload.links,
          data: action.payload.data,
        },
      };
    case actions.LOAD_MORE_START:
      return {
        ...state,
        [action.payload.eventId]: {
          ...state[action.payload.eventId],
          loading: true,
          error: false,
        },
      };
    case actions.LOAD_MORE_SUCCESS:
      return {
        ...state,
        [action.payload.eventId]: {
          ...state[action.payload.eventId],
          loading: false,
          error: false,
          links: action.payload.links,
          data: state[action.payload.eventId].data.concat(action.payload.data),
        },
      };
    case actions.LOAD_MORE_FAIL:
      return {
        ...state,
        [action.initialPayload.eventId]: {
          ...state[action.initialPayload.eventId],
          loading: false,
          error: true,
        },
      };
    case actions.GET_TIME_RANGE_SUCCESS:
      return {
        ...state,
        [action.payload.eventId]: {
          ...state[action.payload.eventId],
          timeRange: action.payload,
        },
      };
    case actions.GET_FILTER_DETAILS_START:
      return {
        ...state,
        filterDetails: action.payload.filterIds.reduce(
          (acc, val) => ({
            ...acc,
            [val]: {
              loading: true,
            },
          }),
          {},
        ),
      };
    case actions.GET_FILTER_DETAILS_SUCCESS:
      return {
        ...state,
        filterDetails: {
          ...state.filterDetails,
          ...action.payload.reduce(
            (acc, val) => ({
              ...acc,
              [val.id]: val,
            }),
            {},
          ),
        },
      };
    default:
      return state;
  }
}
